/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
    constructor() {
      super();
  
      this.form = this.querySelector('form');
      this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
      this.cartElement = document.querySelector('cart-form');    
    }
  
    connectedCallback() {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if(this.querySelector('[data-qty-container]')){
        // this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
      }
    }
  
    /**
     * Product Form Submit event
     *
     * @param {evt} Event instance
     */
    onSubmitHandler(evt) {
      evt.preventDefault();
      const addItems = [];
      const submitButton = this.querySelector('[type="submit"]');
      const qtyInput = this.querySelector('[data-qty-input]');
  
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
  
      addItems.push(JSON.parse(Utility.serializeForm(this.form)));
      const body = JSON.stringify({
        items: addItems,
        sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
      });
      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((res) => {
        let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });
          return false;
        }
  
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        if(qtyInput) qtyInput.value = 1;
        if(this.cartElement){
          this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
          // this.cartElement.getCartData('open_drawer');
        }else{
          window.location.href = window.routes.cart_fetch_url;
        }      
      })
      .catch((e) => {
        window.notificationEle.updateNotification('Error', e, {
          type: 'error',
          timeout: 5000
        });
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
    }
  
    /**
     * Product Form Quantity Input update action
     *
     * @param {event} Event instance
     */
    // manageQtyBtn(event) {
    //   event.preventDefault();
      
    //   let currentTarget = event.currentTarget;
    //   let action = currentTarget.dataset.for || 'increase';
    //   let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    //   let currentQty = parseInt($qtyInput.value) || 1;
    //   let finalQty = 1;
    //   let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
  
    //   if(action == 'decrease' && currentQty <= 1){
    //     if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
    //     return false;
    //   }else if(action == 'decrease'){
    //     finalQty = currentQty - 1;
    //     finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    //   }else{
    //     if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
    //     finalQty = currentQty + 1;
    //   }
  
    //   $qtyInput.value = finalQty;
    // }
  }
  customElements.define('product-form', ProductForm);
  
  /**
   * Dropdown selection for options
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.form = this.closest('form') || this.closest('.form-element');

      // Defensive null checks - prevents errors if form or required elements don't exist
      if (!this.form) {
        console.warn('VariantSelects: form element not found');
        return;
      }

      this.formType = this.form.dataset?.format;
      this.addBtn = this.form.querySelector('[name="add"]');
      this.variant_json = this.form.querySelector('[data-variantJSON]');
      this.variantPicker = this.dataset?.type;
      this.inventoryToleranceRmc = document.getElementById('inventory-tolerance-rmc')?.value || 0;
      this.inventoryToleranceRmcPlus = document.getElementById('inventory-tolerance-rmc-plus')?.value || 0;
      this.inventoryToleranceAddOns = document.getElementById('inventory-tolerance-add-ons')?.value || 0;
      this.inventoryToletance = 0;
    }
  
    connectedCallback() {
      // Defensive check - skip if form not found in constructor
      if (!this.form) return;

      // Element Connected callback
      // if(this.formType == 'product-page') this.onVariantChange('load');
      this.onVariantChange('load');
      this.addEventListener('change', this.onVariantChange.bind(this));

      // Check and select next available Size on load
      setTimeout(() => {
        this.checkAndSelectNextAvailableSize();
      }, 100);
    }
  
    /**
     * Check if current Size swatch is sold out and select next available Size option
     */
    checkAndSelectNextAvailableSize() {
      if(this.currentVariant.inventory_quantity <= Number(this.inventoryToletance)){
        // Find the Size option container with data-option-name="size"
        const sizeContainer = this.querySelector('[data-option-name="size"]');
        if (!sizeContainer) return;

        // Get current selected Size swatch
        const currentSizeSwatch = sizeContainer.querySelector('input[type="radio"]:checked');
        if (!currentSizeSwatch) return;

        // Get all Size swatches
        const sizeSwatches = sizeContainer.querySelectorAll('input[type="radio"]');
        const currentIndex = Array.from(sizeSwatches).indexOf(currentSizeSwatch);
        
        // Find next available Size swatch
        let nextAvailableIndex = -1;
        
        // First, try to find next available swatch after current
        for (let i = currentIndex + 1; i < sizeSwatches.length; i++) {
          const swatch = sizeSwatches[i];
          const swatchElement = swatch.closest('.swatch');
          
          // Check if swatch is available (not disabled and not unavailable)
          if (!swatch.hasAttribute('disabled') && 
              !swatchElement?.classList.contains('unavailable') &&
              !swatchElement?.classList.contains('sold-out')) {
            nextAvailableIndex = i;
            break;
          }
        }
        
        // If no next swatch found, try to find previous available swatch
        if (nextAvailableIndex === -1) {
          for (let i = currentIndex - 1; i >= 0; i--) {
            const swatch = sizeSwatches[i];
            const swatchElement = swatch.closest('.swatch');
            
            if (!swatch.hasAttribute('disabled') && 
                !swatchElement?.classList.contains('unavailable') &&
                !swatchElement?.classList.contains('sold-out')) {
              nextAvailableIndex = i;
              break;
            }
          }
        }
        
        // If still no swatch found, try to find any available swatch
        if (nextAvailableIndex === -1) {
          for (let i = 0; i < sizeSwatches.length; i++) {
            const swatch = sizeSwatches[i];
            const swatchElement = swatch.closest('.swatch');
            
            if (!swatch.hasAttribute('disabled') && 
                !swatchElement?.classList.contains('unavailable') &&
                !swatchElement?.classList.contains('sold-out')) {
              nextAvailableIndex = i;
              break;
            }
          }
        }

        // Click the next available Size swatch
        if (nextAvailableIndex !== -1) {
          const nextSizeSwatch = sizeSwatches[nextAvailableIndex];
          nextSizeSwatch.checked = true;
          nextSizeSwatch.dispatchEvent(new Event('change'));
        }
      }
    }

    /**
     * Trigger this function variant is changed
     * @param {event} _event 
     */
    onVariantChange(_event) {
      // console.log('onVariantChange');
      this.setCurrentVariant();
      this.updateVariantStatuses();
      
      // console.log('this.currentVariant',this.currentVariant);
      if((this.currentVariant.option1 != null && this.currentVariant.option1.toLowerCase() == 'rmc') || (this.currentVariant.option2 != null && this.currentVariant.option2.toLowerCase() == 'rmc') || (this.currentVariant.option3 != null && this.currentVariant.option3.toLowerCase() == 'rmc')){
        this.inventoryToletance = this.inventoryToleranceRmc;
      }else if((this.currentVariant.option1 != null && this.currentVariant.option1.toLowerCase() == 'rmc+') || (this.currentVariant.option2 != null && this.currentVariant.option2.toLowerCase() == 'rmc+') || (this.currentVariant.option3 != null && this.currentVariant.option3.toLowerCase() == 'rmc+')){
        this.inventoryToletance = this.inventoryToleranceRmcPlus;
      }else if((this.currentVariant.option1 != null && this.currentVariant.option1.toLowerCase() == 'add-ons') || (this.currentVariant.option2 != null && this.currentVariant.option2.toLowerCase() == 'add-ons') || (this.currentVariant.option3 != null && this.currentVariant.option3.toLowerCase() == 'add-ons')){
        this.inventoryToletance = this.inventoryToleranceAddOns;
      }
      
      if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new Event('variant:changed'));
      
      if (!this.currentVariant) {
        // this.toggleAddButton('disable');
        this.updateOptionLabel(this.form); 
      } else {
        if(this.formType == 'grid'){
   
          const productGrid = this.closest('[data-product-grid]');
          this.renderProductInfo(this.currentVariant, productGrid);
          this._updateLinks(productGrid); 
        }else{
          const productPage = this.closest('[data-product-container]');
          this.renderProductInfo(this.currentVariant, productPage);
        }
        this.updateURLandID(this.currentVariant);
        // this.toggleAddButton('enable');
      }

      if(this.formType == 'grid'){
        // console.log('this.formType',this.formType);
        this.updateQuantityInput(this.currentVariant);
      }
    }

    updateQuantityInput(currentVariant){
      // console.log('updateQuantityInput');
      let gridParent = this.closest('[data-grid-parent]');
      let featureType = gridParent ? gridParent.getAttribute('data-grid-parent') : null;
      let productId = this.closest('[data-product-grid]').getAttribute('data-product-grid');
      let productGrid = this.closest('[data-product-grid]');
      // if(productGrid){add-to-cart-btn-actual
      //   productGrid.querySelector('[data-qty-input]').setAttribute('max',currentVariant.inventory_quantity);
      // }
      // console.log('featureType',featureType,productId);
      if(featureType === 'customization') {
        const funnelCustomization = document.querySelector('funnel-customization');
        if(funnelCustomization) {
          // Check if any option contains rmc+
          const hasRmcPlus = currentVariant.options.some(option => 
            option.toLowerCase().includes('rmc+')
          );
          
          if(hasRmcPlus) {
            const currentStep = funnelCustomization.modal.querySelector('[customization-data-step]:not(.d-none)');
            if(!currentStep) return;
            const currentStepNumber = parseInt(currentStep.getAttribute('customization-data-step'));
            const currentCustomizedOneTimes = funnelCustomization.customizedOneTimes[currentStepNumber - 1] || [];
            const currentStepArray = funnelCustomization.productArray[currentStepNumber - 1] || [];

            // console.log('currentCustomizedOneTimes',currentCustomizedOneTimes);
            // console.log('currentStepArray',currentStepArray);
            // console.log('this.currentVariant.id',this.currentVariant);

            let foundInAddedCustomizedProducts = currentCustomizedOneTimes.find(item => item.properties.some(prop => prop.name === 'variant_id' && Number(prop.value) == Number(this.currentVariant.id)));
            let foundInCurrentItems = currentStepArray.find(item => item.properties.some(prop => prop.name === 'variant_id' && Number(prop.value) == Number(this.currentVariant.id)));

            // console.log('foundInAddedCustomizedProducts',foundInAddedCustomizedProducts,foundInCurrentItems);
            if(foundInAddedCustomizedProducts && !foundInCurrentItems && this.currentVariant.inventory_quantity <= Number(this.inventoryToletance)){
                let quantity = foundInAddedCustomizedProducts.quantity;
                productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
            }else if(foundInAddedCustomizedProducts && !foundInCurrentItems && this.currentVariant.inventory_quantity > Number(this.inventoryToletance)){
                let quantity = foundInAddedCustomizedProducts.quantity + this.currentVariant.inventory_quantity;
                productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
            }else if(foundInAddedCustomizedProducts && foundInCurrentItems){
                // productGrid.classList.add('product-added');
                let AddedCustomizedQuantity = foundInAddedCustomizedProducts.quantity;
                let CurrentCustomizedQuantity = foundInCurrentItems.quantity;
                if(AddedCustomizedQuantity == CurrentCustomizedQuantity){
                    productGrid.querySelector('[data-qty-input]').setAttribute('max',this.currentVariant.inventory_quantity);
                }else{
                    let difference = AddedCustomizedQuantity - CurrentCustomizedQuantity;
                    if(Math.sign(difference) == -1){
                        let quantity = this.currentVariant.inventory_quantity - Math.abs(difference);
                        productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
                    }else{
                        let quantity = this.currentVariant.inventory_quantity + difference;
                        productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
                    }
                }
            }else if(!foundInAddedCustomizedProducts && foundInCurrentItems){
                // productGrid.classList.add('product-added');
                let quantity = this.currentVariant.inventory_quantity - foundInCurrentItems.quantity;
                productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
            }else if(!foundInAddedCustomizedProducts && !foundInCurrentItems){
                // productGrid.classList.remove('product-added');
                productGrid.querySelector('[data-qty-input]').setAttribute('max',this.currentVariant.inventory_quantity);
            }
            let max = productGrid.querySelector('[data-qty-input]').getAttribute('max');
            if(Number(max) <= Number(this.inventoryToletance)){ 
                this.toggleAddButton('disable');          
                productGrid.querySelector('[data-plus-btn]').classList.add('disable-element');
            }else{
                this.toggleAddButton('enable'); 
                productGrid.querySelector('[data-plus-btn]').classList.remove('disable-element');
            }
            funnelCustomization.updateQuantityInputCustomization(this.currentVariant,productId,productGrid);
          }else{
            productGrid.querySelector('[data-qty-input]').setAttribute('max',this.currentVariant.inventory_quantity);
          }
        }
      }else if(featureType === 'addon'){
        const funnelAddon = document.querySelector('funnel-add-ons');
        if(funnelAddon) {
          let addedAddonProducts = funnelAddon.addedAddonProducts;
          let addonItems = funnelAddon.addonItems;
          let foundInAddedAddonProducts = addedAddonProducts.find(item => item.properties.some(prop => prop.name === 'variant_id' && prop.value == this.currentVariant.id));
          let foundInAddonItems = addonItems.find(item => item.properties.some(prop => prop.name === 'variant_id' && prop.value == this.currentVariant.id));

          // console.log('foundInAddedAddonProducts',foundInAddedAddonProducts,foundInAddonItems);
          if(foundInAddedAddonProducts && !foundInAddonItems && this.currentVariant.inventory_quantity <= Number(this.inventoryToletance)){
            let quantity = foundInAddedAddonProducts.quantity;
            productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
          }else if(foundInAddedAddonProducts && !foundInAddonItems && this.currentVariant.inventory_quantity > Number(this.inventoryToletance)){
            let quantity = foundInAddedAddonProducts.quantity + this.currentVariant.inventory_quantity;
            productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
          }else if(foundInAddedAddonProducts && foundInAddonItems){
            // productGrid.classList.add('product-added');
            let AddedAddonQuantity = foundInAddedAddonProducts.quantity;
            let AddonQuantity = foundInAddonItems.quantity;
            if(AddedAddonQuantity == AddonQuantity){
              productGrid.querySelector('[data-qty-input]').setAttribute('max',currentVariant.inventory_quantity);
            }else{
              let difference = AddedAddonQuantity - AddonQuantity;
              if(Math.sign(difference) == -1){
                let quantity = currentVariant.inventory_quantity - Math.abs(difference);
                productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
              }else{
                let quantity = currentVariant.inventory_quantity + difference;
                productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
              }
            }
          }else if(!foundInAddedAddonProducts && foundInAddonItems){
            // productGrid.classList.add('product-added');
            let quantity = this.currentVariant.inventory_quantity - foundInAddonItems.quantity;
            productGrid.querySelector('[data-qty-input]').setAttribute('max',quantity);
          }else if(!foundInAddedAddonProducts && !foundInAddonItems){
            // productGrid.classList.remove('product-added');
            productGrid.querySelector('[data-qty-input]').setAttribute('max',currentVariant.inventory_quantity);
          }
          let max = productGrid.querySelector('[data-qty-input]').getAttribute('max');
          // console.log('max111',max);
          if(Number(max) <= Number(this.inventoryToletance)){ 
            this.toggleAddButton('disable');          
            productGrid.querySelector('[data-plus-btn]').classList.add('disable-element');
          }else{
            this.toggleAddButton('enable'); 
            productGrid.querySelector('[data-plus-btn]').classList.remove('disable-element');
          }
          funnelAddon.updateQuantityInputAddon(currentVariant,productId);
        }
      }else if(featureType === 'nmc'){
        productGrid.querySelector('[data-qty-input]').setAttribute('max',this.currentVariant.inventory_quantity);
        let max = productGrid.querySelector('[data-qty-input]').getAttribute('max');
        if(Number(max) <= 0){ 
            this.toggleAddButton('disable');          
            productGrid.querySelector('[data-plus-btn]').classList.add('disable-element');
        }else{
            this.toggleAddButton('enable'); 
            productGrid.querySelector('[data-plus-btn]').classList.remove('disable-element');
        }
      }
    }
  
    /**
     * Change product variant url link in product card when variant is being updated
     * @param {element} productGrid 
     */
    _updateLinks(productGrid){
      // console.log('_updateLinks',productGrid);
      if(!this.currentVariant || !productGrid) return;
      const variantURL = `?variant=${this.currentVariant.id}`;
      const formLinks = productGrid.querySelectorAll('.product-link');
      formLinks.forEach(link => {
        let href = link.href.split('?')[0];
        link.href = href + variantURL;
      });
  
      productGrid.querySelectorAll('[data-return-pdp-url]').forEach(loginBtn => loginBtn.addEventListener('click', this.storePDPURL.bind(this)));
      
    }
  
    storePDPURL(event){
      // event.preventDefault();
      let getCurrentURL = window.location.href;
      // console.log('getCurrentURL',getCurrentURL);
      let collectionName = event.currentTarget.getAttribute('data-return-pdp-url');
      Utility.setCookie('getStoredPDPURL', getCurrentURL, 1);
      Utility.setCookie('getStoredPDPColl', collectionName, 1);
    }
  
    /**
     * Fetch selected options from dropdown
     */
    _getOptionsFromSelect() {
      let options = [];
      this.querySelectorAll('.variant_selector').forEach((selector)=>{
        options.push(selector.value);
      });
      return options;
    }
  
    /**
     * Fetch selected options from radio
     */
    _getOptionsFromRadio() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
      return fieldsets.map((fieldset) => {
        const checkedInput = Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)'))
          .find((radio) => radio.checked);
        return checkedInput ? checkedInput.value : null; // or '' or any fallback value
      });
      // return fieldsets.map((fieldset) => {
      //   return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
      // });
    }
  
    /**
     * change value of currentVariant when variant being changed 
     */
    setCurrentVariant() {
      
      this.currentVariant = false;
      let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
  
      let variantsArray = this._getVariantData();
      variantsArray.find((variant) => {
        let mappedValues = variant.options.map((option, index) => {
          return options[index] === option;
        });
  
        if(!mappedValues.includes(false)){
          this.currentVariant = variant;
          return;
        }
      });
    }
  
    /**
     * Update selected option name label
     */
    updateOptionLabel(form){
      let options = form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let labelID = 'option'+option.dataset.optionindex;
        const label = option.querySelector('.selected-option');
        if(!label || !labelID) return;
        label.innerHTML = this.currentVariant[labelID];
      });
    }
  
    /**
     * Update URL on variant change event
     * @param {JSON} currentVariant 
     */
    updateURLandID(currentVariant) {
      if (!currentVariant) return;
  
      if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);
  
      const input = this.form.querySelector('input[name="id"]');
      input.value = currentVariant.id;
    }
  
    /**
     * Render Price details based on current variant
     */
    priceUpdate(currentVariant, container){
        const priceElement = container.querySelector('[data-currentPrice]');
        const comparePriceElement = container.querySelector('[data-comparePrice]');
        const addButton = container.querySelector('.addtocart-btn');
        const addTextWrapper = addButton?.querySelector('.add-text-wrapper');
        const qtyInput = container.querySelector('[data-qty-input]');
        
        if (!priceElement) return;
        if (!addButton) return;

        if (currentVariant.price === 0) {
            priceElement.style.display = 'none';
            if (comparePriceElement) {
                comparePriceElement.classList.add('d-none');
            }
            if (addTextWrapper && currentVariant.inventory_quantity > Number(this.inventoryToletance)) {
                addTextWrapper.textContent = 'Add';
                addButton.classList.add('btn-outline');
                addButton.classList.remove('btn-dark');
                addButton.classList.remove('disable-element');
                addButton.removeAttribute('disabled');
            } else if (addTextWrapper && currentVariant.inventory_quantity <= Number(this.inventoryToletance)) {
              addTextWrapper.textContent = 'Sold Out';
              addButton.classList.add('btn-outline');
              addButton.classList.add('disable-element');
              addButton.classList.remove('btn-dark');
              addButton.setAttribute('disabled', true);
            }
            return;
        }

        priceElement.style.display = '';
        if (comparePriceElement) {
            comparePriceElement.classList.remove('d-none');
        }

        if (currentVariant.compare_at_price > currentVariant.price) {
            if (comparePriceElement) {
                comparePriceElement.innerHTML = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
                comparePriceElement.classList.remove('d-none');
            }
            priceElement.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
            priceElement.classList.add('danger-price');
            priceElement.classList.add('fw-medium');
        } else {
            if (comparePriceElement) {
                comparePriceElement.classList.add('d-none');
            }
            priceElement.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format) + ' value';
            priceElement.classList.remove('danger-price');
            priceElement.classList.remove('fw-medium');
        }

        // Update add button text with price if price > 0
        if(addButton.hasAttribute('data-addtocart-edit')){
          addTextWrapper.textContent = 'Save Changes';
          addButton.classList.add('btn-outline');
          addButton.classList.remove('btn-dark');
        }else{
          if((addTextWrapper.hasAttribute('data-add-text-wrapper') && currentVariant.price == 0) || (addButton.hasAttribute('data-add-addon-product') && currentVariant.price > 0)){
            if (addTextWrapper) {
              if(qtyInput.getAttribute('max') <= Number(this.inventoryToletance)){
                addTextWrapper.textContent = 'Sold Out';
                addButton.setAttribute('disabled', true);
              }else{
                addTextWrapper.textContent = `Add`;
                addButton.removeAttribute('disabled');
              }
              // addTextWrapper.textContent = `Add`;
              addButton.classList.add('btn-outline');
              addButton.classList.remove('btn-dark');
            }
          }else{
            
            if (addTextWrapper && currentVariant.price > 0) {
              const formattedPrice = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
              // Remove decimal places from price
              const priceWithoutDecimals = formattedPrice.replace(/\.00$/, '');
              addTextWrapper.textContent = `Add to Box +${priceWithoutDecimals}`;
              addButton.classList.remove('btn-outline');
              addButton.classList.add('btn-dark');
            }
          }
        }
        

        // Update discount badge
        const discountBadge = container.querySelector('[data-discount-badge]');
        if (discountBadge) {
          if (currentVariant.compare_at_price > currentVariant.price && currentVariant.price > 0) {
            const discountPercentage = Math.round(((currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price) * 100);
            discountBadge.textContent = `${discountPercentage}% OFF`;
            discountBadge.classList.remove('d-none');
          } else {
            discountBadge.classList.add('d-none');
          }
        }
    }
  
    getMemberVariant(currentVariant){
      let memberVariant = null;
      let variantsArray = this._getVariantData();
      let lowercaseOpt = currentVariant.options.map(v => v.toLowerCase());
      let optionIndex = lowercaseOpt.indexOf("non-member") + 1;
    
      variantsArray.forEach(function(value, index) {
        if(optionIndex == 1){
          if(currentVariant.option2 == value.option2 && currentVariant.option3 == value.option3 && value.option1.toLowerCase() == 'member'){
            memberVariant = value;
          }
        }else if(optionIndex == 2){
          if(currentVariant.option1 == value.option1 && currentVariant.option3 == value.option3 && value.option2.toLowerCase() == 'member'){
            memberVariant = value;
          }
        }else if(optionIndex == 3){
          if(currentVariant.option1 == value.option1 && currentVariant.option2 == value.option2 && value.option3.toLowerCase() == 'member'){
            memberVariant = value;
          }
        }
      });
      if(memberVariant != null){
        return memberVariant;
      }
    }
  
    getNonMemberVariant(currentVariant){
      let memberVariant = null;
      let variantsArray = this._getVariantData();
      let lowercaseOpt = currentVariant.options.map(v => v.toLowerCase());
      let optionIndex = lowercaseOpt.indexOf("member") + 1;
    
      variantsArray.forEach(function(value, index) {
        if(optionIndex == 1){
          if(currentVariant.option2 == value.option2 && currentVariant.option3 == value.option3 && value.option1.toLowerCase() == 'non-member'){
            memberVariant = value;
          }
        }else if(optionIndex == 2){
          if(currentVariant.option1 == value.option1 && currentVariant.option3 == value.option3 && value.option2.toLowerCase() == 'non-member'){
            memberVariant = value;
          }
        }else if(optionIndex == 3){
          if(currentVariant.option1 == value.option1 && currentVariant.option2 == value.option2 && value.option3.toLowerCase() == 'non-member'){
            memberVariant = value;
          }
        }
      });
      if(memberVariant != null){
        return memberVariant;
      }
    }
  
    // updateVariantStatuses() {
    //   const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    //   if(inputWrappers.length > 1){
    //     var selectedOptionOneVariants = this.variantData.filter(
    //       (variant) => this.querySelector(':checked').value === variant.option1
    //     );
    //   }else{
    //     var selectedOptionOneVariants = this.variantData;
    //   }
     
    //   inputWrappers.forEach((option, index) => {
    //     console.log('heyyyyy',inputWrappers[index]);
    //     if(inputWrappers.length > 1){
    //       if (index == 0) return;
    //     }
  
    //     const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
    //     if(inputWrappers.length > 1){
    //       const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
    //       const availableOptionInputsValue = selectedOptionOneVariants
    //         .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
    //         .map((variantOption) => variantOption[`option${index + 1}`]);
    //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
    //     }else{
    //       const availableOptionInputsValue = selectedOptionOneVariants
    //         .filter((variant) => variant.available)
    //         .map((variantOption) => variantOption[`option${index + 1}`]);
    //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
    //     }
    //   });
    // }
  
    updateVariantStatuses() {
      // const selectedOptionOneVariants = this.variantData.filter(
      //   (variant) => this.querySelector(':checked').value === variant.option1
      // );
  
      const selectedOptionOneVariants = this.variantData;
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        // if (index === 0) return;
        if(index == 0){
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        }else{
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        }
  
        if(inputWrappers[index].querySelector(':checked') && inputWrappers[index].querySelector(':checked').hasAttribute('disabled')){
          let radioButtons = inputWrappers[index].querySelectorAll('input[type="radio"]')
          for (var i = 0; i < radioButtons.length; i++) {
            if (!radioButtons[i].hasAttribute('disabled')) {
                radioButtons[i].checked = true;
                break;
            }
        }
        }
        
      });
      this.setCurrentVariant();
    }
    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach((element) => {
        const value = element.getAttribute('value');
        const availableElement = availableValuesList.includes(value);
        
        if (element.tagName === 'INPUT') {
          // Remove disabled attribute to make all variants selectable
          element.removeAttribute('disabled');
          
          // Add a class to indicate availability status
          if (!availableElement) {
            element.closest('.swatch').classList.add('unavailable');
          } else {
            element.closest('.swatch').classList.remove('unavailable');
          }
        } else if (element.tagName === 'OPTION') {
          element.innerText = value;
        }
      });
    }
    
    
    // setInputAvailability(elementList, availableValuesList) {
    //   elementList.forEach((element) => {
    //     const value = element.getAttribute('value');
    //     const availableElement = availableValuesList.includes(value);
  
    //     if (element.tagName === 'INPUT') {
    //       element.toggleAttribute('disabled', !availableElement)
    //     } else if (element.tagName === 'OPTION') {
    //       element.innerText = availableElement
    //         ? value
    //         : window.variantStrings.unavailable_with_option.replace('[value]', value);
    //     }
    //   });
    // }
  
    /**
     * Render Product data based on current variant
     * @param {object} currentVariant 
     * @param {element} container 
     */
    renderProductInfo(currentVariant, container) {
      if(!currentVariant || !container) return;
     
      this.priceUpdate(currentVariant, container);
      this.updateOptionLabel(this.form); 
  
      // Update discount badge
      const discountBadge = container.querySelector('[data-discount-badge]');
      if (discountBadge) {
        if (currentVariant.compare_at_price > currentVariant.price && currentVariant.price > 0) {
          const discountPercentage = Math.round(((currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price) * 100);
          discountBadge.textContent = `${discountPercentage}% OFF`;
          discountBadge.classList.remove('d-none');
        } else {
          discountBadge.classList.add('d-none');
        }
      }

      const featured_image = currentVariant.featured_image || null;
      if(featured_image != null){
        if(this.formType == 'grid'){
          const featuredImage = container.querySelector('[data-feauredImage]');
          featuredImage.src = currentVariant.featured_image.src;
          featuredImage.srcset = currentVariant.featured_image.src;
        }else{
          let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
          if(this.formType == 'quickshop'){
            imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
          }
          
          if(!imageSlide) return;
    
          let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
          if(this.formType == 'quickshop' && quickShopSlider){
            quickShopSlider.slideTo(slideIndex, 0, false);
          }else if(productSlider){
            productSlider.slideTo(slideIndex, 0, false);
          }
        }
      }
    }
  
    /**
     * Toggle the button based on product availability ( add to cart / soldOut )
     * @param {*} status enable / disable
     */
    toggleAddButton(status) {
      
      if (!this.addBtn) return;
  
      if (status == 'disable') {
        this.addBtn.setAttribute('disabled', true);
        this.addBtn.classList.add('disable-element');
        if(this.addBtn.querySelector('.add-text-wrapper'))
          this.addBtn.querySelector('.add-text-wrapper').textContent = 'Sold Out';
          this.addBtn.classList.add('btn-outline');
          this.addBtn.classList.remove('btn-dark');
      } else {
        this.addBtn.removeAttribute('disabled');
        this.addBtn.classList.remove('disable-element');
        if(this.form.classList.contains('cart-upsell-form')){
            if(this.addBtn.querySelector('.add-text-wrapper')) this.addBtn.querySelector('.add-text-wrapper').textContent = window.variantStrings.upsellAddText;
        } else {
          if(this.addBtn.querySelector('.add-text-wrapper')) {
            if(this.addBtn.querySelector('.add-text-wrapper').hasAttribute('data-add-text-wrapper') && this.currentVariant.price == 0){
              this.addBtn.querySelector('.add-text-wrapper').textContent = 'Add';
              this.addBtn.removeAttribute('disabled');
              this.addBtn.classList.add('btn-outline');
              this.addBtn.classList.remove('btn-dark');
            }else{
              if ((this.currentVariant && this.currentVariant.price === 0) || (this.addBtn.hasAttribute('data-add-addon-product') && this.currentVariant.price > 0)) {
                this.addBtn.querySelector('.add-text-wrapper').textContent = 'Add';
                this.addBtn.removeAttribute('disabled');
                this.addBtn.classList.add('btn-outline');
                this.addBtn.classList.remove('btn-dark');
              } else {
                const price = this.currentVariant.price / 100;
                const priceWithoutDecimals = price.toString().replace(/\.00$/, '');
                this.addBtn.querySelector('.add-text-wrapper').textContent = `Add to Box +$${priceWithoutDecimals}`;
                this.addBtn.classList.remove('btn-outline');
                this.addBtn.classList.add('btn-dark');  
                this.addBtn.removeAttribute('disabled');
              }
            }
          }
        }
      }
    }
  
    /**
     * Store the all the variants json
     */
    _getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);
  
  /**
   * Radio Button swatch
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
  
      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;
  
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle;
          if(swatch.hasAttribute('data-hex-code') == true){
            swatchStyle = swatch.getAttribute('data-hex-code');
            swatch.querySelector('.swatch-label').setAttribute('style', `background-color: ${swatchStyle}`);
          }else{
            swatchStyle = Utility.getSwatchStyle(colorHandle);
            swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
          }
          
          
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);